import { composeSMSThunk } from '../../redux/thunks/sms';
import CustomDropdown from '../reusable/dropdown';
import CustomInput from '../reusable/input';
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import LabelWrapper from '../wrapper/label';
import { settingComposingFlagSMS } from '../../redux/slices/sms';
import { smsMessageComposeSchema } from '../../schema/sms_schema';
import { useParams } from 'react-router';
import { useRef } from 'react';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, Typography } from '@mui/material';
import { emailAndPhoneOptions, fieldsOptions } from '../../helper';
import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

const SMSComposeComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const { selectedLead } = useSelector((state: RootState) => state.lead);
    const { selectedDeal } = useSelector((state: RootState) => state.deal);
    const { contacts } = useSelector((state: RootState) => state.contact);
    const { loaders } = useSelector((state: RootState) => state.sms);

    const navigateBackHandler = () => {
        dispatch(settingComposingFlagSMS(false));
    };

    const composeSMSHandler = async (values: {
        to: string;
        message: string;
    }) => {
        try {
            await dispatch(composeSMSThunk({
                ...values,
                client_id: id ? parseInt(id as string, 10) : 0
            })).unwrap();
            dispatch(settingComposingFlagSMS(false));
        } catch (e) {
            //
        }
    };

    const allContactsRaw = [
        ...contacts.map((item) => ({
            label: item.contact_number || '',
            value: item.contact_number || ''
        })),
        {
           label: selectedDeal?.phone || '',
            value: selectedDeal?.phone || ''
        }
    ];

    const seen = new Set<string>();
    const allContacts = allContactsRaw.filter((contact) => {
        if (!contact.value) return false;
        if (seen.has(contact.value)) return false;
        seen.add(contact.value);
        return true;
    });

    return (
        <Formik
            initialValues={{
                to: !location.pathname.includes('/lead-management') && !location.pathname.includes('/app/leads') && selectedDeal?.phone ? selectedDeal?.phone : selectedLead?.phone || '',
                message: ''
            }}
            validationSchema={smsMessageComposeSchema}
            onSubmit={composeSMSHandler}
        >
            {({ values, setFieldValue, handleChange, handleBlur, errors, touched }) => {
                const messageInputRef = useRef<HTMLTextAreaElement>(null);
                const handleAddField = (field: string) => {
                    const textarea = messageInputRef.current;
                    if (!textarea) {
                        // fallback to appending
                        setFieldValue('message', `${values.message} [${field}] `);
                        return;
                    }
                    const start = textarea.selectionStart || 0;
                    const end = textarea.selectionEnd || 0;
                    const insertText = `[${field}]`;
                    const newMessage =
                        values.message.slice(0, start) +
                        insertText +
                        values.message.slice(end);
                    setFieldValue('message', newMessage);

                    // Restore focus and cursor after insertion
                    setTimeout(() => {
                        textarea.focus();
                        const cursorPos = start + insertText.length;
                        textarea.setSelectionRange(cursorPos, cursorPos);
                    }, 0);
                };
                return <Form>
                    <Box display="flex" flexDirection="column" gap={2}>
                        <Box display="flex" justifyContent="space-between">
                            <Button startIcon={<KeyboardArrowLeftRounded />} variant="text" color="secondary" disabled={loaders.isCreating} onClick={navigateBackHandler}>Back</Button>
                            <Typography variant="h4" color="textSecondary">Send SMS</Typography>
                            <Box></Box>
                        </Box>
                        {!location.pathname.includes('/lead-management') && !location.pathname.includes('/app/leads')
                            ? <CustomDropdown
                                label="To:"
                                options={allContacts}
                                onChange={(e) => setFieldValue('to', e.target.value)}
                                value={values.to}
                                disabled={loaders.isCreating}
                                fullWidth
                            />
                            : <CustomInput
                                label="To:"
                                value={values.to}
                                disabled={loaders.isCreating}
                                fullWidth
                            />}
                        <Box display="flex" flexDirection="column" gap={2}>
                            <Box display="flex" justifyContent="space-between" alignItems="end">
                                <LabelWrapper label="Message:" />
                                <Box>
                                    <CustomDropdown
                                        options={(location.pathname.includes('/lead-management') || location.pathname.includes('/app/leads')) ? emailAndPhoneOptions : fieldsOptions}
                                        value=""
                                        placeholder="Add Field"
                                        disabled={loaders.isCreating}
                                        // onChange={(e) => setFieldValue('message', `${values.message} [${e.target.value}]`)}
                                        onChange={(e) => handleAddField(e.target.value as string)}
                                        sx={{
                                            marginBottom: 0
                                        }}
                                    />
                                </Box>
                            </Box>
                            <CustomInput
                                type="textarea"
                                row={8}
                                placeholder="Type Here..."
                                value={values.message}
                                error={errors.message && touched.message}
                                onChange={handleChange('message')}
                                onBlur={handleBlur('message')}
                                disabled={loaders.isCreating}
                                fullWidth
                                inputRef={messageInputRef}
                            /></Box>
                        <Box display="flex" justifyContent="end" alignItems="center" gap={2}>
                            <Button variant="outlined" color="secondary" disabled={loaders.isCreating} size="large" onClick={navigateBackHandler}>Cancel</Button>
                            <Button type="submit" variant="contained" disabled={loaders.isCreating} size="large">Send</Button>
                        </Box>
                    </Box>
                </Form>;
            }}
        </Formik>
    );
};

export default SMSComposeComponent;